import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { isNil } from 'lodash-es';
import { AspectType, CommentAssetPosition } from '@/types';

dayjs.extend(duration);

export function groupReviewByTakeIndex(arr: CommentAssetPosition[]): Record<any, CommentAssetPosition[]> {
  return arr.reduce((acc: Record<any, CommentAssetPosition[]>, cur: CommentAssetPosition) => {
    let { takeIndex } = cur;
    if (isNil(takeIndex)) {
      takeIndex = 0;
    }
    if (!acc[takeIndex]) {
      acc[takeIndex] = [];
    }
    acc[takeIndex].push(cur);
    return acc;
  }, {});
}

export function groupReviewByFrameIndex(arr: CommentAssetPosition[]): Record<string, CommentAssetPosition[]> {
  const grouped = arr.reduce((acc: Record<string, CommentAssetPosition[]>, cur) => {
    const { frameIndex } = cur;
    const index = Math.round(frameIndex);

    if (!acc[index]) {
      acc[index] = [];
    }

    acc[index].push(cur);
    return acc;
  }, {});
  //新cur，按照createTime时间顺序，最新的放在前面

  Object.keys(grouped).forEach(key => {
    grouped[key] = grouped[key].sort((a, b) => {
      return new Date(b.createTime).getTime() - new Date(a.createTime).getTime();
    });
  });
  return grouped;
}

export function isReviewExist(map: Record<string, CommentAssetPosition[]>, frameIndex: number) {
  return map[frameIndex.toString()] && map[frameIndex.toString()].length > 0;
}

export function getNumberOfDigits(num: number) {
  if (num === 0) return 1;
  return Math.floor(Math.log10(num)) + 1;
}
export function fillZero(num: number, digit: number) {
  const numDigit = getNumberOfDigits(num);
  if (numDigit >= digit) return num;
  return `${'0'.repeat(digit - numDigit)}${num}`;
}
export function keepTwoDecimal(num: number) {
  return Math.round(num * 100) / 100;
}

export const computeImageTransformInContainer = (
  params: {
    imageWidth;
    imageHeight;
    containerWidth;
    containerHeight;
  },
  maxScale = 1,
) => {
  const { imageWidth, imageHeight, containerWidth, containerHeight } = params;
  const wRatio = containerWidth / imageWidth;
  const hRatio = containerHeight / imageHeight;
  const scaleRatio = Math.min(wRatio, hRatio, maxScale);

  const width = Math.round(imageWidth * scaleRatio);
  const height = Math.round(imageHeight * scaleRatio);
  return {
    width,
    height,
    scale: scaleRatio,
  };
};
// 判断图片的宽高是否超出容器的宽高
export const computeImageAspectMode = (params: { imageWidth; imageHeight; containerWidth; containerHeight }) => {
  const { imageWidth, imageHeight, containerWidth, containerHeight } = params;
  if (imageWidth >= containerWidth || imageHeight >= containerHeight) {
    return AspectType.aspectFit;
  }
  return AspectType.aspectFill;
};

export const calculateTime = (config: any) => {
  const { frameIndex, frameRate } = config;
  if (isNil(frameIndex) || isNil(frameRate) || String(frameRate) === '0') return '00:00:00';
  const seconds = frameIndex / frameRate;

  const durationObj = dayjs.duration(seconds, 'seconds');
  const hours = fillZero(durationObj.hours(), 2);
  const minutes = fillZero(durationObj.minutes(), 2);
  const secondsLeft = fillZero(durationObj.seconds(), 2);

  return `${hours}:${minutes}:${secondsLeft}`;
};
